import { useState, useEffect } from 'react';
import { fetchVirksomhedsoplysninger, FALLBACK_VIRKSOMHED } from '../lib/cms';

export default function FloatingCta() {
  const [virksomhed, setVirksomhed] = useState(FALLBACK_VIRKSOMHED);

  useEffect(() => {
    async function loadInfo() {
      const data = await fetchVirksomhedsoplysninger();
      if (data) setVirksomhed(data);
    }
    loadInfo();
  }, []);

  return (
    <aside
      aria-label="Hurtig kontakt"
      className="fixed bottom-5 right-4 sm:bottom-6 sm:right-6 z-40 flex flex-col gap-2.5 sm:gap-3 items-center pointer-events-auto"
    >
      {/* 1. Phone Button (tel:) */}
      <a
        href={`tel:${virksomhed.telefon.replace(/\s+/g, '')}`}
        className="w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-sky-600 hover:bg-sky-500 text-white shadow-lg shadow-sky-950/40 border border-sky-400/40 flex items-center justify-center hover:scale-105 active:scale-95 transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 group"
        aria-label={`Ring til ${virksomhed.firmanavn} på ${virksomhed.telefon}`}
        title={`Ring til ${virksomhed.telefon}`}
      >
        <i
          className="fa-solid fa-phone text-base sm:text-lg group-hover:rotate-12 transition-transform duration-200"
          aria-hidden="true"
        />
      </a>

      {/* 2. Email Button (mailto:) */}
      <a
        href={`mailto:${virksomhed.email}`}
        className="w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-slate-900 hover:bg-slate-800 text-sky-400 hover:text-white shadow-lg shadow-slate-950/50 border border-slate-700 hover:border-slate-600 flex items-center justify-center hover:scale-105 active:scale-95 transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 group"
        aria-label={`Send e-mail til ${virksomhed.email}`}
        title={`Send e-mail til ${virksomhed.email}`}
      >
        <i
          className="fa-solid fa-envelope text-base sm:text-lg group-hover:-translate-y-0.5 transition-transform duration-200"
          aria-hidden="true"
        />
      </a>

      {/* 3. Facebook Profile Button */}
      {virksomhed.facebook_url && (
        <a
          href={virksomhed.facebook_url}
          target="_blank"
          rel="noopener noreferrer"
          className="w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-[#1877F2] hover:bg-[#166fe5] text-white shadow-lg shadow-blue-950/40 border border-blue-400/30 flex items-center justify-center hover:scale-105 active:scale-95 transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 group"
          aria-label={`Besøg ${virksomhed.firmanavn} på Facebook`}
          title={`Besøg ${virksomhed.firmanavn} på Facebook`}
        >
          <i
            className="fa-brands fa-facebook-f text-base sm:text-lg group-hover:scale-110 transition-transform duration-200"
            aria-hidden="true"
          />
        </a>
      )}
    </aside>
  );
}
